import { useNavigate } from 'react-router-dom'
import Header from 'components/headers/withGreenBack'

/**
 * Which kind of box? — the `+` in the funds header used to go straight to the
 * moneypool wizard, which is why صندوق قرعه‌کشی could not be created from the
 * PWA at all.
 *
 * The two products differ in how people join, and the copy says so: a
 * moneypool has a join link, a cashbox does not — its manager adds every
 * member by phone number.
 */
export default function ChooseBoxTypePage() {
    const navigate = useNavigate()

    return (
        <div className="bg-white min-h-screen">
            <Header title="ساخت صندوق" />

            <div className="px-4 pt-2">
                <button
                    type="button"
                    onClick={() => navigate('/add-box/moneyPool')}
                    className="w-full text-right rounded-card border border-divider bg-white p-4 mb-3 active:scale-[0.99]"
                >
                    <p className="text-base font-bold text-black">
                        صندوق قرض‌الحسنه
                    </p>
                    <p className="text-sm text-text-secondary mt-1 leading-6">
                        اعضا حق عضویت ماهانه می‌پردازند و از محل سرمایه‌ی صندوق
                        وام می‌گیرند. عضوگیری با لینک هم ممکن است.
                    </p>
                </button>

                <button
                    type="button"
                    onClick={() => navigate('/cashbox/create')}
                    className="w-full text-right rounded-card border border-divider bg-white p-4 active:scale-[0.99]"
                >
                    <p className="text-base font-bold text-black">
                        صندوق قرعه‌کشی
                    </p>
                    <p className="text-sm text-text-secondary mt-1 leading-6">
                        هر نوبت همه سهم خود را می‌پردازند و با قرعه‌کشی، وام به
                        یک یا چند نفر می‌رسد. اعضا را فقط مدیر اضافه می‌کند و
                        لینک عضویت ندارد.
                    </p>
                </button>
            </div>
        </div>
    )
}
